import CommonService from '@/api/CommonService'
import { loadLanguageAsync } from '@/plugins/i18n'
import LocalStorage from '@/utils/LocalStorage'
import _ from 'lodash'
import Vue from 'vue'
import google from '@/plugins/google'
import constant from '../../../configs/constant'

const state = {
  configs: {},
  reCaptchaV3Key: null,
  currentLang: null,
  languages: [],
  walletPagination: {},
  pagination: {},
  listPrice24h: [],
  openMenu: false,
  comPagination: {},
  comRefPagination: {},
  comDailyPagination: {},
  comGlobalBonusHistoryPaging: {},
  comLeaderBonusHistoryPaging: {},
  comFundCareHistoryPaging: {},
  comSummaryBonus: {},
  currentMatrixNode: {}
}

const getters = {
  configs: state => state.configs,
  reCaptchaV3Key: state => state.reCaptchaV3Key,
  languages: state => state.languages,
  currentLang: state => state.currentLang,
  pagination: state => state.pagination,
  walletPagination: state => state.walletPagination,
  listPrice24h: state => state.listPrice24h,
  openMenu: state => state.openMenu,
  comPagination: state => state.comPagination,
  comRefPagination: state => state.comRefPagination,
  comDailyPagination: state => state.comDailyPagination,
  comGlobalBonusHistoryPaging: state => state.comGlobalBonusHistoryPaging,
  comLeaderBonusHistoryPaging: state => state.comLeaderBonusHistoryPaging,
  comFundCareHistoryPaging: state => state.comFundCareHistoryPaging,
  comSummaryBonus: state => state.comSummaryBonus,
  currentMatrixNode: state => state.currentMatrixNode
}

const mutations = {
  SET_COM_GLOBAL_PAGINATION: (state, data) => {
    state.comGlobalBonusHistoryPaging = data
  },
  SET_COM_LEADER_PAGINATION: (state, data) => {
    state.comLeaderBonusHistoryPaging = data
  },
  SET_COM_FUND_CARE_PAGINATION: (state, data) => {
    state.comFundCareHistoryPaging = data
  },
  SET_COM_PAGINATION: (state, data) => {
    state.comPagination = data
  },
  SET_COM_REF_PAGINATION: (state, data) => {
    state.comRefPagination = data
  },
  SET_DAILY_PAGINATION: (state, data) => {
    state.comDailyPagination = data
  },
  SET_PAGINATION: (state, data) => {
    state.pagination = data
  },
  SET_WALLET_HISTORY_PAGINATION: (state, data) => {
    state.walletPagination = data
  },
  SET_SYS_CONFIG: (state, data) => {
    state.configs = data
    state.reCaptchaV3Key = data.reCaptchaV3Key
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?render=' +
        state.reCaptchaV3Key
    )
    document.head.appendChild(recaptchaScript)
    Vue.prototype.$google = google
  },
  SET_CURRENT_LANG (state, val) {
    state.currentLang = val
  },
  SET_LANGUAGE: (state, data) => {
    state.languages = data
  },
  SET_LIST_PRICE_24H: (state, data) => {
    state.listPrice24h = data
  },
  SET_OPEN_MENU: state => {
    state.openMenu = !state.openMenu
  },
  SET_COM_SUMMARY_BONUS: (state, data) => {
    state.comSummaryBonus = data
  },
  SET_CURRENT_MATRIX_NODE: (state, data) => {
    state.currentMatrixNode = data
  }
}

const actions = {
  setWalletHistoryPagination ({ commit }, data) {
    commit('SET_WALLET_HISTORY_PAGINATION', data)
  },
  setComGlobalPagination ({ commit }, data) {
    commit('SET_COM_GLOBAL_PAGINATION', data || {})
  },
  setComLeaderBonusPagination ({ commit }, data) {
    commit('SET_COM_LEADER_PAGINATION', data || {})
  },
  setComFundCarePagination ({ commit }, data) {
    commit('SET_COM_FUND_CARE_PAGINATION', data || {})
  },
  setComPagination ({ commit }, data) {
    commit('SET_COM_PAGINATION', data || {})
  },
  setComRefPagination ({ commit }, data) {
    commit('SET_COM_REF_PAGINATION', data || {})
  },
  setDailyPagination ({ commit }, data) {
    commit('SET_DAILY_PAGINATION', data || {})
  },
  setPagination ({ commit }, data) {
    commit('SET_PAGINATION', data || {})
  },
  showSuccessMsg (__, message) {
    this._vm.$notify.success({
      message: message,
      duration: 2000
    })
  },
  showErrorMsg (__, message) {
    this._vm.$notify.error({
      message: message,
      customClass: 'notify-error',
      duration: 2000
    })
  },
  getSystemConfigs ({ commit }) {
    const temp = {
      isAllowLogin: true,
      isAllowRegister: true,
      isAllowDeposit: true
    }
    CommonService.getSystemConfig().then(resConfigs => {
      const conf = Object.assign(resConfigs.data, temp)
      commit('SET_SYS_CONFIG', conf)
    }).catch(e => {
      commit('SET_SYS_CONFIG', temp)
    })
  },
  getLanguages ({ commit }) {
    (async () => {
      let langDefault = null
      let cacheLang = LocalStorage.getItem('language')
      const languages = constant.LANGUAGE_LINK ? (await CommonService.getLanguages()) : []
      commit('SET_LANGUAGE', languages)
      langDefault = ((languages.length && languages[0] && languages[0].code) || 'en')
      cacheLang = _.find(languages, { code: cacheLang }) ? cacheLang : langDefault
      LocalStorage.setItem('language', cacheLang)
      const defaultLang = cacheLang || langDefault
      loadLanguageAsync(defaultLang).then(rs => {
        commit('SET_CURRENT_LANG', defaultLang)
        Promise.resolve(true)
      })
    })()
  },
  setNewLanguage ({ commit }, lang) {
    LocalStorage.setItem('language', lang)
    loadLanguageAsync(lang).then(rs => {
      commit('SET_CURRENT_LANG', lang)
    })
  },
  setComSummaryBonus ({ commit }, data) {
    commit('SET_COM_SUMMARY_BONUS', data)
  },
  setCurrentMatrixNode ({ commit }, data) {
    commit('SET_CURRENT_MATRIX_NODE', data)
  }
}

export default { state, getters, mutations, actions }
